exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag[data-v-3687819b]{position:relative;display:inline-block;background:#fff;border-radius:.04rem;padding:0 .04rem;font-size:.1rem;font-family:PingFangSC-Regular,PingFang SC;color:var(--color-theme,#f9ac19);line-height:.16rem}.tag[data-v-3687819b]:not(:first-child){margin-left:.06rem}.tag.active[data-v-3687819b]{background:#fff5eb}.tag[data-v-3687819b]:before{content:\"\";position:absolute;top:-50%;bottom:-50%;left:-50%;right:-50%;width:200%;height:200%;-webkit-transform:scale(.5);transform:scale(.5);border:solid 1px var(--color-theme,#f9ac19);border-radius:8px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
